__turbopack_context__.v({
  "pairedInputs": "PairedInputs-module__DrF8DG__pairedInputs",
});
